export interface AuthModel {
  auth_token: string
}

export type SecondFactorMethod = 'passkey' | 'totp' | 'recovery_code'

/** Digits of an authenticator code. */
export const TOTP_CODE_LENGTH = 6

/** What the password step answers for an account protected by a second factor: no token yet. */
export interface SecondFactorChallenge {
  secondFactorRequired: true
  challenge: string
  methods: SecondFactorMethod[]
}

export type LoginResult = AuthModel | SecondFactorChallenge

export const isSecondFactorChallenge = (result: LoginResult): result is SecondFactorChallenge =>
  (result as SecondFactorChallenge).secondFactorRequired === true

export interface UserModel {
  id: number
  uuid: string
  roles: Array<ROLE>
  merchants?: Array<number>
  cashBoxes?: Array<number>
  cashBox: number
  secondFactorEnabled?: boolean
}

export interface UserModelResponse {
  success: boolean
  userData: UserModel
}

export enum ROLE {
  ROLE_SMS_PROVIDER = 'ROLE_SMS_PROVIDER',
  ROLE_PLATFORM_NOTIFICATOR = 'ROLE_PLATFORM_NOTIFICATOR',
  ROLE_PLATFORM = 'ROLE_PLATFORM',
  ROLE_EMPLOYEE = 'ROLE_EMPLOYEE',
  ROLE_CASHIER = 'ROLE_CASHIER',
  ROLE_OPERATOR = 'ROLE_OPERATOR',
  ROLE_SENIOR_CASHIER = 'ROLE_SENIOR_CASHIER',
  ROLE_SENIOR_OPERATOR = 'ROLE_SENIOR_OPERATOR',
  ROLE_MANAGER = 'ROLE_MANAGER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MATCHING_OPERATOR = 'ROLE_MATCHING_OPERATOR',
  ROLE_MERCHANT_PAYMENTS_OPERATOR = 'ROLE_MERCHANT_PAYMENTS_OPERATOR',
  ROLE_MERCHANT_MANAGER = 'ROLE_MERCHANT_MANAGER',
}
